import { createFileRoute } from '@tanstack/react-router';
import { ResetPasswordForm } from '@web/modules/auth/reset-password-form';

export interface ResetPasswordSearch {
  /** The token of the e-mailed link. */
  token?: string | undefined;
}

export const Route = createFileRoute('/_auth/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch =>
    typeof search['token'] === 'string' ? { token: search['token'] } : {},
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  return <ResetPasswordForm token={token} />;
}
